import $ from 'jquery';

export default class Filters {
  constructor($elem) {
    this.$elem = $elem;


    this.click__close = this.click__close.bind(this);
    this.click__filter = this.click__filter.bind(this);

    this._init();
  }

  click__filter(ev) {
      ev.preventDefault();
      let $target = $(ev.currentTarget),
          offset = $target.offset(),
          x = (offset.left - 240),
          y = (offset.top + $target.height() + 20);

      // this.$elem.css({ left : x, top : y });

      if (this.$elem.hasClass('visually-hidden')) {
          this.$elem.removeClass('visually-hidden');
          this.$elem.show();
      } else {
          this.$elem.addClass('visually-hidden');
          this.$elem.hide();
      }
  }

  click__close(ev) {
    ev.preventDefault();

    this.$elem.addClass('visually-hidden');
    this.$elem.hide();
  }

  _init() {
    $('body')
      .on('click', '.filter__trigger', this.click__filter);

    this.$elem
      .on('click', '.close', this.click__close);
  }
}
